import { useState, useEffect } from 'react';
import axios from 'axios';
import './index.css';
import './admin.css';
import ProjectManager from './ProjectManager';
import { createPortal } from 'react-dom';
import MediaModal from './Modals/MediaModal';
import ProjectModal from './Modals/ProjectModal';
import { marked } from 'marked';
import DOMPurify from 'dompurify';

export default function Dashboard({ token, setToken, toast }) {
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + token;
    const [files, setFiles] = useState([]);
    const [projects, setProjects] = useState([]);
    const [project, setProject] = useState(null);
    const [about, setAbout] = useState("");

    // {type: 0, data: {MediaID: int, Source: string, MediaType: string} } // Edit Media
    // {type: 1, data: {Source: [string], MediaType: string} } // Create media
    // {type: 2, data: {ProjectName: string?, ProjectDesc: string?, Date: string?, ProjectDesc2: string?, Date2: string?} } // Create project
    // {type: 3, data: {Title: string, Source: string} // Edit main page
    const [editing, setEditing] = useState(null);

    async function updateAbout() {
        await axios.put(( window.API_ENDPOINT || "/api/" )+"about", {"text":about})
            .then(res=>{
                if (res.data)
                    setAbout(res.data || "")
                    toast.success("Succes!");
            })
            .catch(r=>{
                if (r.status === 403) {
                    toast.error("Session expired. Please log in again.");
                    return setToken(null);
                }
                toast.error("Something went wrong... Please try again.");
                console.log(r);
                getProjects();
            })
    }

    function getProjects() {
        axios.get(( window.API_ENDPOINT || "/api/" )+"projects")
            .then(res => {
                setProjects(res.data);
                if (project && project.ProjectID) {
                    setProject(res.data.find(p=>p.ProjectID===project.ProjectID));
                }
            })
    }

    function openMediaModal(idx) {
        if (idx === -1) return setEditing({"type": 1, "data": {"Source": [], "MediaType": "1"}});
        setEditing({
        "type": 0,
        "data": {
                    "MediaID": project.MediaIDs.split(";")[idx],
                    "Source": project.Sources.split(";")[idx], 
                    "MediaType": project.Types.split(";")[idx]
                }
        });
    }

    async function deleteMedia() {
        if (!editing || !editing.type === 0) return console.log("erm.. what the sigma?");
        await axios.delete(( window.API_ENDPOINT || "/api/" )+"projects/media/"+editing.data.MediaID)
            .then((res)=>{
                toast.success("Succes! AffectedRows: "+res.data.affectedRows);
                getProjects();
            }).catch((r)=>{
                if (r.status === 403) {
                    toast.error("Session expired. Please log in again.");
                    return setToken(null);
                }
                toast.error("Something went wrong... Please try again.");
                console.log(r);
                getProjects();
            });
        setEditing(null);
    }

    async function submit() {
        if (!editing) return;

        let req;
        if (editing.type === 0) {
            req = axios.put(( window.API_ENDPOINT || "/api/" )+"projects", {
                "source": editing.data.Source,
                "mediaType": Number(editing.data.MediaType),
                "mediaID": Number(editing.data.MediaID)
            })
        } else if (editing.type === 1 && editing.data.Source.length > 0) {
            if (editing.data.MediaType === "1") {
                req = axios.post(( window.API_ENDPOINT || "/api/" )+"projects", {
                    "projectID": project.ProjectID,
                    "mediaType": 1,
                    "pathNames": editing.data.Source.filter(name=>!name.endsWith("/")&&name!=="")
                })
            }
            else {
                req = axios.post(( window.API_ENDPOINT || "/api/" )+"projects", {
                    "projectID": project.ProjectID,
                    "mediaType": 2,
                    "pathNames": [editing.data.Source]
                })
            }
        }  else if (editing.type === 2) {
            if (!editing.data.Date) return setEditing(null);
            req = axios.post(( window.API_ENDPOINT || "/api/" )+"projects", {
                    "projectName": editing.data.ProjectName || "",
                    "projectDesc": editing.data.ProjectDesc || "",
                    "date": editing.data.Date
                })
        }  else {
            return setEditing(null);
        }

        req.then(res=>{
            toast.success("Succes! AffectedRows: "+res.data.affectedRows);
            getProjects();
            setEditing(null);
        }).catch((r)=>{
            if (r.status === 403) {
                toast.error("Session expired. Please log in again.");
                return setToken(null);
            }
            toast.error("Something went wrong... Please try again.");
            console.log(r);
            getProjects();
        });
    }

    async function submitFolder(dir) {
        if (!dir) return setEditing(null);

        axios.post(( window.API_ENDPOINT || "/api/" )+"projects", {
                    "dir": dir || "",
                    "projectName": editing.data.ProjectName2 || "",
                    "projectDesc": editing.data.ProjectDesc2 || "",
                    "date": editing.data.Date2,
                }).then(res=>{
                    toast.success("Succes! AffectedRows: "+res.data.affectedRows);
                    getProjects();
                    setEditing(null);
                }).catch((r)=>{
                    if (r.status === 403) {
                        toast.error("Session expired. Please log in again.");
                        return setToken(null);
                    }
                    toast.error("Something went wrong... Please try again.");
                    console.log(r);
                    getProjects();
                });

        return setEditing(null);
    }

    async function handleButtonClick(n) {
        setEditing(null);
    }

    useEffect(()=>{
        axios.get(( window.API_ENDPOINT || "/api/" )+"projects")
            .then(res => {
                setProjects(res.data);
            })
        axios.get(( window.API_ENDPOINT || "/api/" )+"about")
            .then(res => {
                setAbout(res.data);
            })
        axios.get(( window.API_ENDPOINT || "/api/" )+"files")
            .then(res => {
                setFiles(res.data);
            });
    }, []);

    return (
        <>
            <p className="aboutTitle">Projects</p>
            <div id="projects">
                <div className="sidebar">
                    <div className='projectsList'>
                        {projects.map(project=>(
                            <button key={"buttonn"+project.ProjectID} className="projectsList__btn" onClick={()=>setProject(project)}>{project.ProjectName}</button>
                        ))}
                    </div>
                    <button className="projectsList__btn" onClick={()=>setEditing({"type":2,"data":{}})}>Add Project</button>
                </div>
                <ProjectManager
                    project={project}
                    key={project ? project.ProjectID : null}
                    reload={getProjects}
                    openMediaModal={openMediaModal}
                    toast={toast}
                    files={files}
                    setToken={setToken}
                />
            </div>

            <p className="aboutTitle">About</p>
            <div id="aboutEditor">
                <textarea id="aboutInput" value={about} onChange={e=>setAbout(e.target.value)} className="aboutPage"></textarea>
                <div id="aboutOutput" className="aboutPage main" dangerouslySetInnerHTML={{__html:DOMPurify.sanitize(marked.parse(about))}}></div>
                <button onClick={updateAbout}>Submit</button>
            </div>

            {/*<p className="aboutTitle">Main Page</p>
            <div id="mainEditor">
                <button onClick={()=>setEditing({type: 3, data:{title: "lel", source: "lul"}})}>Change main page</button>
            </div>*/}

            {editing && 
                createPortal(
                    <>
                        {editing.type === 0 && 
                            <MediaModal
                                files={files}
                                data={editing.data}
                                callback={(data)=>setEditing({"type":0, "data":{...editing.data, ...data}})}
                                closeModal={handleButtonClick}
                                onSubmit={submit}
                                onDelete={deleteMedia}
                                onCancel={handleButtonClick}
                            />
                        }
                        {editing.type === 1 && 
                            <MediaModal
                                files={files}
                                data={editing.data}
                                callback={(data)=>setEditing({"type":1, "data":{...editing.data, ...data}})}
                                closeModal={handleButtonClick}
                                onSubmit={submit}
                                onCancel={handleButtonClick}
                                multiple
                            />
                        }
                        {editing.type === 2 && 
                            <ProjectModal
                                data={editing.data}
                                callback={(data)=>setEditing({"type":2, "data":{...editing.data, ...data}})}
                                onSubmit={submit}
                                onSubmitFolder={submitFolder}
                                onCancel={handleButtonClick}
                                closeModal={handleButtonClick}
                                files={files}
                            />
                        }
                        {editing.type === 3 && 
                            <MediaModal
                                files={files}
                                data={editing.data}
                                callback={(data)=>setEditing({"type":3, "data":{...editing.data, ...data}})}
                                closeModal={handleButtonClick}
                                onSubmit={submit}
                                onDelete={deleteMedia}
                                onCancel={handleButtonClick}
                            />
                        }
                    </>,
                    document.body
                )
            }
        </>
    )
}